import { render, staticRenderFns } from "./PrescriptionInfo.vue?vue&type=template&id=d512fb04&"
import script from "./PrescriptionInfo.vue?vue&type=script&lang=js&"
export * from "./PrescriptionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports